// AppShell der People-App (DESIGN §3.1.1): SkipLink → NavRail (md+) → TopBar → main → Dock → BottomNav.
// Inhalt mit 12 Abstand neben der Rail, rechts 16, max. 1440; mobil Rand 16 und Platz für die Bottom-Nav.
import { type ReactNode } from 'react';
import { cn } from '../kern/cn';
import { SkipLink } from '../kern/Misc';
import { PageChromeProvider } from '../kern/page-chrome';
import { TooltipProvider } from './parts';

export interface AppShellProps {
  /** NavRail (ab md). */
  rail: ReactNode;
  /** TopBar (die Shell der Plattform füllt Titel und Aktionen). */
  topbar: ReactNode;
  /** BottomNav (unter md). */
  bottomNav: ReactNode;
  /** DockPanel (Chat). */
  dock?: ReactNode;
  /** Ab 2xl schiebt das offene Dock den Inhalt. */
  dockOpen?: boolean;
  /** Banner ganz oben („View as …“, Demo). */
  banner?: ReactNode;
  /** Toaster, Dialoge der Shell (Sitzung abgelaufen …). */
  overlays?: ReactNode;
  children: ReactNode;
}

export function AppShell({
  rail,
  topbar,
  bottomNav,
  dock,
  dockOpen,
  banner,
  overlays,
  children,
}: AppShellProps) {
  return (
    <TooltipProvider delayDuration={400}>
      <PageChromeProvider>
        <div
          data-shell="people"
          className="min-h-dvh bg-page text-fg max-md:[--bar-bottom-offset:calc(var(--spacing-bottomnav)+env(safe-area-inset-bottom))]"
        >
          <SkipLink />
          {banner}
          {rail}
          <div
            className={cn(
              'flex min-h-dvh min-w-0 flex-col md:pl-rail',
              dockOpen && '2xl:pr-[calc(var(--spacing-dock)+16px)]',
            )}
          >
            <div className="px-4 md:pr-4 md:pl-3">{topbar}</div>
            <main
              id="main"
              tabIndex={-1}
              className="mx-auto w-full max-w-page-max min-w-0 flex-1 px-4 pt-2 pb-[calc(var(--bar-bottom-offset,0px)+24px)] outline-none md:pr-4 md:pb-10 md:pl-3"
            >
              {children}
            </main>
          </div>
          {dock}
          {bottomNav}
          {overlays}
        </div>
      </PageChromeProvider>
    </TooltipProvider>
  );
}
